import React, {Component} from 'react'

import withData from '../../utils/withData';


class Asset extends Component {

  render () {

      const assets = this.props.datastore.get('assets');

      if(!assets) return null;

      const _this = this;

      const ids = this.props.id;

   
      
      const matches = (assets.filter((i) => {
        return (ids.indexOf(i.id) != -1)
      }) )

 


      let response = matches.map((asset,ix) => {
        
        let rendered = _this.props.render(asset,ix);
        return {...rendered,key:ix}


      });
      
 

    return response;
  }
}

export default withData(Asset)



// WEBPACK FOOTER //
// ./src/js/models/Asset/Asset.jsx